export const CATEGORIES = [
  {
    slug: "agricultural-commodities",
    name: "Agricultural Commodities",
    short: "Agriculture",
    summary:
      "Direct farm-to-export sourcing with quality verification and traceability.",
    bullets: ["Millets", "Ancient Grains", "Sesame Seeds", "Spices", "Pulses"],
  },
  {
    slug: "fresh-produce",
    name: "Fresh Produce",
    short: "Fresh Produce",
    summary:
      "Export-ready produce with cold-chain support and documentation assistance.",
    bullets: ["Mangoes", "Pomegranates", "Bananas", "Seasonal Fruits"],
  },
  {
    slug: "sustainable-packaging",
    name: "Sustainable Packaging",
    short: "Sustainable Packaging",
    summary:
      "Plastic-free alternatives for UK and European brands.",
    bullets: ["Jute Bags", "Eco Packaging", "Retail Packaging", "Corporate Merchandise"],
  },
  {
    slug: "essential-oils-botanicals",
    name: "Essential Oils & Botanicals",
    short: "Botanicals",
    summary:
      "Natural ingredients for wellness, cosmetic and industrial applications.",
    bullets: ["Turmeric Extracts", "Herbal Extracts", "Essential Oils", "Natural Ingredients"],
  },
  {
    slug: "industrial-engineering",
    name: "Industrial & Engineering Products",
    short: "Industrial",
    summary:
      "Reliable sourcing from India's growing manufacturing ecosystem.",
    bullets: ["Steel Products", "Fabrication", "Machinery Components", "Industrial Equipment"],
  },
  {
    slug: "precious-metals-custom",
    name: "Precious Metals & Custom Manufacturing",
    short: "Precious Metals & Custom",
    summary:
      "Direct access to manufacturers and bespoke production capabilities.",
    bullets: ["Gold Jewellery", "Silver Products", "Custom Designs"],
  },
];
